import { BluebookParameters } from '@t/api/bluebook/bluebook-dashboard-parameters.model';
import { ReturnReportParameters } from '@t/api/bluebook/client-return/client-return-parameters.models';
import { ICagingHistoryParams } from '@t/api/bluebook/dailies/caging-parameters.model';

export const bluebookQueryKeys = {
  clients: {
    all: ['Clients'] as const,
    filteredClients: (parameters?: BluebookParameters) =>
      [...bluebookQueryKeys.clients.all, { ...parameters }] as const,
  },
  dailies: {
    all: ['dailies'] as const,
    cagingHistory: (params?: ICagingHistoryParams) =>
      [...bluebookQueryKeys.dailies.all, 'cagingHistory', params] as const,
    cagingHistorySummary: (params?: ICagingHistoryParams) =>
      [...bluebookQueryKeys.dailies.all, 'cagingHistorySummary', params] as const,
  },
  returns: {
    all: ['returns'] as const,
    cagingHistory: (mailCode?: string) => [...bluebookQueryKeys.returns.all, 'cagingHistory', mailCode] as const,
    clientReturns: (parameters: ReturnReportParameters) =>
      [...bluebookQueryKeys.returns.all, { ...parameters }] as const,
    mailTypes: (clientAcronym?: string) => [...bluebookQueryKeys.returns.all, 'mailTypes', clientAcronym] as const,
  },
  utilities: {
    all: ['utility'] as const,
    incidental: (clientAcronym: string) => [...bluebookQueryKeys.utilities.all, 'incidentals', clientAcronym] as const,
    listRental: (clientAcronym: string) => [...bluebookQueryKeys.utilities.all, 'list-rental', clientAcronym] as const,
    whiteMail: (clientAcronym: string) => [...bluebookQueryKeys.utilities.all, 'white-mail', clientAcronym] as const,
  },
} as const;
